import { render, staticRenderFns } from "./ModalMainTemplate.vue?vue&type=template&id=74fd6790&"
import script from "./ModalMainTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalMainTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports